import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Truncate from 'react-truncate';
import t from '../../i18n/I18n';
import './ShowMoreText.css';

export default class ShowMoreText extends Component {
  static defaultProps = {
    lines: 4,
    more: t('SEE_MORE'),
    less: t('SEE_LESS'),
    onTextClickEnable: false
  };

  static propTypes = {
    children: PropTypes.node,
    lines: PropTypes.number,
    more: PropTypes.node,
    less: PropTypes.node,
    onTextClickEnable: PropTypes.bool
  };

  state = {
    expanded: false,
    truncated: false
  };

  handleTruncate = (truncated) => {
    if (truncated !== this.state.truncated) {
      this.setState({
        truncated
      });
    }
  };

  toggleLines = (event) => {
    event.preventDefault();

    this.setState({
      expanded: !this.state.expanded
    });
  };

  onTextClick = (event) => {
    event.preventDefault();
    const { onTextClickEnable } = this.props;
    const { expanded, truncated } = this.state;
    if (!onTextClickEnable || expanded || !truncated) {
      return;
    }
    this.setState({
      expanded: !this.state.expanded
    });
  };

  render() {
    const { children, more, less, lines } = this.props;

    const { expanded, truncated } = this.state;

    return (
      <div onClick={this.onTextClick}>
        <Truncate
          width={this.props.width}
          lines={!expanded && lines}
          ellipsis={
            <span>
              ...{' '}
              <a href="#" className="showlessButtonText" onClick={this.toggleLines}>
                {more}
              </a>
            </span>
          }
          onTruncate={this.handleTruncate}>
          {children}
        </Truncate>
        {/* {!truncated &&
          expanded && (
            <span>
              {' '}
              <a href="#" className="showlessButtonText" onClick={this.toggleLines}>
                {less}
              </a>
            </span>
          )} */}
      </div>
    );
  }
}
